import { BankDetailProps } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'

import type { Request } from '../../index'


type ApiParams = {
  bank_details: {
    bank_title: string
    bik: string
    checking_account: string
    corr_account: string
  }
}

export const convertParams = ({
  bankTitle,
  bik,
  checkingAccount,
  corrAccount,
}: BankDetailProps): [ApiParams, null] => {
  const result = {
    bank_details: {
      bank_title: bankTitle,
      bik,
      checking_account: checkingAccount,
      corr_account: corrAccount,
    },
  }
  return [result, null]
}

type ApiResult = {
  result: 'success'
}

export const convertResult = (result: ApiResult): boolean => {
  return !!result
}

export const POST_BANK_DETAILS: Request<BankDetailProps, boolean, void> = [
  'account/bank_details',
  'post',
  ['data', 'bank_details'],
]
